module.exports = __webpack_public_path__ + "img/version_sigh.608c681c.png";